import { useEffect, useRef } from "react";
import { useAuthUser } from "./auth-context";
import { rehydrateOnboardingStore } from "@/lib/stores/onboarding-store";

/**
 * Keeps the onboarding store pointed at the signed-in account's storage slot.
 *
 * The store's persist key is namespaced by user id, but zustand hydrates once
 * at module load. When the account changes within a tab - sign out, sign in as
 * someone else - the in-memory state has to be re-read from the new slot.
 */
export function OnboardingScopeSync() {
  const { user } = useAuthUser();
  const lastUserIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const userId = user?.userId;
    if (!userId || userId === lastUserIdRef.current) return;
    lastUserIdRef.current = userId;
    rehydrateOnboardingStore();
  }, [user?.userId]);

  return null;
}
